import React from 'react';
import Resizer from 'react-image-file-resizer';

import { Button, Input, FormGroup, Label, FormFeedback, FormText } from 'reactstrap';

function ImageFileFieldGroup(props) {
    const { field, value, label, error, setValue, description, className, maxWidth, maxHeight } = props;

    const resizeFile = (file) => new Promise(resolve => {
        Resizer.imageFileResizer(file, maxWidth | 300, maxHeight | 300, 'JPEG', 85, 0,
            uri => {
                resolve(uri);
            },
            'base64'
        );
    });

    async function onChange(e) {
        const file = e.target.files[0];
        if (file) {
            const image = await resizeFile(file);
            setValue(image); 
        }
    }

    function removeImage(e) {
        setValue(null);
    }

    return (
        <FormGroup className={className}>
            <Label for={field}>{label}</Label>
            <Input
                type="file"
                name={field}
                accept=".jpeg, .jpg"
                onChange={onChange}
                invalid={error ? true : false}
            />
            {value && <div><img src={value} /></div>}
            {value && <Button type="button" onClick={removeImage} color="warning">Kép törlése</Button>}
            {error && <FormFeedback>{error}</FormFeedback>}
            {description && <FormText>{description}</FormText>}
            {props.children}
        </FormGroup>
    );
}

export default ImageFileFieldGroup;
